import { useContext } from 'react';
import Container from 'react-bootstrap/Container';
import { ThemeContext } from '../../../context/theme-context';
import NaturalQueryInterface from '../../../Components/NaturalQuery/NaturalQueryInterface';
import * as S from './styled';

export default function CadNaturalQuery() {
  const { collapsed } = useContext(ThemeContext);

  return (
    <Container className={collapsed ? 'contenteLayoutCollapsed' : 'contenteLayout'}>
      <S.QueryWrapper>
        <S.QueryContainer>
          <NaturalQueryInterface />
        </S.QueryContainer>
      </S.QueryWrapper>
    </Container>
  );
}